// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { PhysicsSettings } from "../settings/PhysicsSettings";
import { ReplaySettings } from "../settings/Settings";
import { compressData, uncompressData } from "./Compression";
import { ReplayLogger } from "./ReplayLogger";
export var ReplayData = function () {
    this.reset();
};
ReplayData.prototype.setPowerupIcon = function (props, time) {
    'use strict';
    var t = time ? time : this.time;
    var move = {};
    move["power"] = "generic";
    move["properties"] = props;
    move["time"] = t;
    this.data.push(move);
};
ReplayData.prototype.setBlockState = function (blocks, time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["blocks"] = blocks;
    move["time"] = t;
    this.data.push(move);
    ReplayLogger.log("Recorded blockstate");
};
ReplayData.prototype.setShot = function (shot, time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["time"] = t + 1;
    move["shot"] = shot;
    this.data.push(move);
    ReplayLogger.log("Recorded shot");
};
ReplayData.prototype.setEnd = function (time, skipCameraReset) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["time"] = t;
    this.data.push(move);
    if (!skipCameraReset) {
        this.setCameraResetStart(t);
    }
    ReplayLogger.log("Recorded end");
};
ReplayData.prototype.setStone = function (props, time) {
    'use strict';
    var t = time ? time : this.time;
    var move = {};
    move["power"] = "stone";
    move["properties"] = props;
    move["time"] = t;
    this.data.push(move);
    this.setCameraResetStart(t);
    ReplayLogger.log("Recorded powerup ");
};
ReplayData.prototype.setSwapPigs = function (props, time) {
    'use strict';
    var t = time ? time : this.time;
    var move = {};
    move["power"] = "pigSwap";
    move["properties"] = props;
    move["time"] = t;
    this.data.push(move);
    this.setCameraResetStart(t);
    ReplayLogger.log("Recorded powerup");
};
ReplayData.prototype.setIce = function (props, time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["power"] = "ice";
    move["properties"] = props;
    move["time"] = t;
    this.data.push(move);
    this.setCameraResetStart(t);
    ReplayLogger.log("Recorded powerup");
};
ReplayData.prototype.setTNT = function (props, time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["power"] = "TNT";
    move["properties"] = props;
    move["time"] = t;
    this.data.push(move);
    this.setCameraResetStart(t);
    ReplayLogger.log("Recorded powerup");
};
ReplayData.prototype.setLife = function (props, time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["power"] = "shield";
    move["properties"] = props;
    move["time"] = t;
    this.data.push(move);
    this.setCameraResetStart(t);
    ReplayLogger.log("Recorded powerup");
};
ReplayData.prototype.setSpecial = function (time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["time"] = t;
    move["special"] = true;
    this.data.push(move);
    ReplayLogger.log("Recorded special");
};
ReplayData.prototype.setIdleStart = function (time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["time"] = t;
    move["startIdle"] = true;
    this.currentIdleStart = this.data.length;
    this.data.push(move);
    ReplayLogger.log("Recorded idlestart");
};
ReplayData.prototype.setCameraPanStart = function (time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["time"] = Math.floor(t - ((1 / PhysicsSettings.physicsTimeStep) * ReplaySettings.shotPanDelay));
    move["panToSlingshot"] = true;
    this.cameraData.push(move);
};
ReplayData.prototype.setCameraResetStart = function (time) {
    "use strict";
    var t = time ? time : this.time;
    var move = {};
    move["time"] = Math.floor(t - ((1 / PhysicsSettings.physicsTimeStep) * ReplaySettings.powerupPanDelay));
    move["panToDefault"] = true;
    this.cameraData.push(move);
};
ReplayData.prototype.reset = function () {
    "use strict";
    this.data = [];
    this.cameraData = [];
    this.time = 0;
    this.currentIdleStart = -1;
};
ReplayData.prototype.updateTime = function () {
    "use strict";
    this.time++;
};
ReplayData.prototype.resetIdle = function () {
    if (this.currentIdleStart != -1 && this.currentIdleStart == this.data.length - 1) {
        this.data.splice(this.currentIdleStart, 1);
        this.currentIdleStart = -1;
    }
};
ReplayData.prototype.deleteLastState = function (type) {
    "use strict";
    if (this.data.length > 0 && this.data[this.data.length - 1][type]) {
        this.data.splice(this.data.length - 1, 1);
    }
};
ReplayData.prototype.getData = function () {
    "use strict";
    return this.data;
};
ReplayData.prototype.getCameraData = function () {
    "use strict";
    return this.cameraData;
};
ReplayData.prototype.getCompressedData = function () {
    "use strict";
    var data = [];
    for (var i = 0; i < this.data.length; i++) {
        if (this.data[i]["blocks"]) {
            var blockState = compressData(this.data[i]["blocks"]["array"]);
            var event = JSON.parse(JSON.stringify(this.data[i]));
            event["blocks"]["array"] = blockState;
            data.push(event);
        }
        else {
            data.push(this.data[i]);
        }
    }
    return data;
};
ReplayData.getUncompressedData = function (data) {
    "use strict";
    var uncompressedData = [];
    for (var i = 0; i < data.length; i++) {
        if (data[i]["blocks"]) {
            var blockState = uncompressData(data[i]["blocks"]["array"]);
            var event = JSON.parse(JSON.stringify(data[i]));
            event["blocks"]["array"] = blockState;
            uncompressedData.push(event);
        }
        else {
            uncompressedData.push(data[i]);
        }
    }
    return uncompressedData;
};
